import React, { useState } from 'react';
import { supabase } from '../lib/supabase';

export default function Login() {
  const [email, setEmail]       = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading]   = useState(false);
  const [error, setError]       = useState('');

  async function handleLogin(e) {
    e.preventDefault();
    setLoading(true);
    setError('');
    const { error } = await supabase.auth.signInWithPassword({ email, password });
    if (error) setError(error.message);
    setLoading(false);
  }

  return (
    <div style={{
      height:'100vh', display:'flex', alignItems:'center', justifyContent:'center',
      background:'var(--bg)',
    }}>
      <div style={{
        width:360, background:'var(--surface)', border:'1px solid var(--border)',
        borderRadius:8, padding:40,
      }}>
        {/* Logo */}
        <div style={{ marginBottom:32, textAlign:'center' }}>
          <div style={{ display:'flex', alignItems:'center', justifyContent:'center', gap:10, marginBottom:8 }}>
            <div style={{ width:8, height:8, borderRadius:'50%', background:'var(--accent)' }}/>
            <span style={{ fontFamily:'var(--serif)', fontSize:22, fontWeight:400, letterSpacing:'-0.02em' }}>Cerebro Risk</span>
          </div>
          <div style={{ fontSize:11, color:'var(--muted)', letterSpacing:'0.06em', textTransform:'uppercase' }}>Underwriting Platform</div>
        </div>

        {/* Form */}
        <form onSubmit={handleLogin}>
          <div style={{ marginBottom:16 }}>
            <label style={{ display:'block', fontSize:10, color:'var(--muted)', textTransform:'uppercase', letterSpacing:'0.08em', marginBottom:6 }}>Email</label>
            <input
              type="email" value={email} onChange={e => setEmail(e.target.value)} required
              placeholder="you@company.com"
              style={{ width:'100%', height:40, padding:'0 12px', background:'var(--surface2)', border:'1px solid var(--border)', borderRadius:4, color:'var(--text)', fontSize:13 }}
            />
          </div>
          <div style={{ marginBottom:24 }}>
            <label style={{ display:'block', fontSize:10, color:'var(--muted)', textTransform:'uppercase', letterSpacing:'0.08em', marginBottom:6 }}>Password</label>
            <input
              type="password" value={password} onChange={e => setPassword(e.target.value)} required
              placeholder="••••••••"
              style={{ width:'100%', height:40, padding:'0 12px', background:'var(--surface2)', border:'1px solid var(--border)', borderRadius:4, color:'var(--text)', fontSize:13 }}
            />
          </div>
          {error && (
            <div style={{ background:'var(--red-bg)', border:'1px solid var(--red-b)', borderRadius:4, padding:'10px 12px', fontSize:12, color:'var(--red)', marginBottom:16 }}>
              {error}
            </div>
          )}
          <button type="submit" disabled={loading} style={{
            width:'100%', height:42, borderRadius:4, border:'none',
            background:'var(--accent)', color:'#fff', fontSize:13, fontWeight:500,
            fontFamily:'var(--mono)', cursor: loading ? 'not-allowed' : 'pointer',
            opacity: loading ? 0.7 : 1, letterSpacing:'0.04em',
          }}>
            {loading ? 'Signing in...' : 'Sign in'}
          </button>
        </form>

        <div style={{ marginTop:24, textAlign:'center', fontSize:11, color:'var(--muted)' }}>
          Access restricted to authorized underwriters
        </div>
      </div>
    </div>
  );
}
